<template>
  <div
    v-bind:style="{
      'margin-left': marginLeft,
      width: width,
    }"
  >
    <p class="title-1">VIII. LINK UNTUK SITUS WEB LAINNYA</p>
    <p class="Desc">
      Layanan Dompet Kilat mungkin berisi link ke situs web pihak ketiga atau
      layanan yang tidak dimiliki atau dikendalikan oleh Dompet Kilat. Dompet
      Kilat tidak memiliki kontrol atas, dan tidak bertanggung jawab atas, isi,
      kebijakan privasi, atau praktik dari situs-situs web atau layanan pihak
      ketiga. Dompet Kilat tidak bertanggung jawab, baik secara langsung atau
      tidak langsung, atas kerusakan atau kehilangan yang disebabkan atau diduga
      disebabkan oleh atau berhubungan dengan penggunaan atau ketergantungan
      pada konten atau layanan yang tersedia melalui situs web atau layanan dari
      pihak ketiga. Kami sangat menyarankan Anda untuk membaca syarat dan
      ketentuan dan kebijakan privasi dari situs-situs web pihak ketiga atau
      layanan yang Anda kunjungi.
    </p>
    <p class="title-1">IX. PEMBATASAN TANGGUNG JAWAB</p>

    <p class="Desc">
      Dompet Kilat ataupun karyawan-karyawannya tidak bertanggung jawab dan
      tidak berhak untuk memberikan ganti rugi apabila terjadi pelanggaran
      Syarat dan Ketentuan ini, atau Perjanjian lainnya dengan Dompet Kilat yang
      disebabkan oleh kesalahan atau kelalaian Anda.
    </p>
    <p class="Desc">
      Pesan yang disampaikan melalui koneksi internet tidak dapat dijamin
      sepenuhnya keamanannya dan dapat saja tertahan, hilang atau mengalami
      perubahan. Kami tidak bertanggung jawab atas pesan yang hilang, diubah
      oleh pihak ketiga, atau tertahan dan kami tidak bertanggung jawab secara
      material kepada Anda atau siapa saja atas kerusakan atau hal lainnya
      sehubungan dengan pesan yang dikirim oleh Anda kepada kami atau kami
      kepada Anda melalui koneksi internet
    </p>
    <p class="title-1">X. PENANGGUHAN</p>

    <p class="Desc">
      Kami dapat mengakhiri atau menangguhkan akses ke Layanan Dompet Kilat
      segera, tanpa pemberitahuan terlebih dahulu, untuk alasan apapun, jika
      Anda melanggar Syarat dan Ketentuan. Semua Syarat dan Ketentuan yang pada
      dasarnya dapat bertahan dari penangguhan, akan tetap berlaku tanpa
      batasan, seperti ketentuan kepemilikan, Syarat dan Ketentuan garansi,
      ganti rugi dan batasan tanggung jawab. Setelah penangguhan, hak Anda untuk
      menggunakan Layanan akan segera dihentikan. Jika Anda ingin menangguhkan
      akun Anda, Anda harus menghubungi kami untuk dapat menghentikan penggunaan
      Layanan Dompet Kilat.
    </p>
    <p class="title-1">XI. HUKUM YANG BERLAKU DAN PENYELESAIAN SENGKETA</p>

    <p class="Desc">
      Syarat dan Ketentuan ini dan setiap kewajiban non-kontraktual lain yang
      timbul dari atau sehubungan dengannya diatur oleh hukum negara Republik
      Indonesia. Anda sepakat bahwa segala tindakan hukum apapun atau sengketa
      yang mungkin timbul akibat sehubungan dengan penggunaan Situs dan Aplikasi
      akan diselesaikan dan diputuskan secara final pada Pengadilan Negeri
      Jakarta Selatan.
    </p>

    <p class="title-1">XII. PERUBAHAN SYARAT DAN KETENTUAN</p>

    <p class="Desc">
      Kami berhak untuk memodifikasi atau mengganti Syarat dan Ketentuan ini
      setiap saat. Bila terdapat perubahan, kami akan menginformasikan minimal 2
      hari kalender sebelum Syarat dan Ketentuan tersebut berlaku. Dengan terus
      mengakses atau menggunakan Layanan Dompet Kilat maka Anda setuju untuk
      terikat oleh perubahan Syarat dan Ketentuan yang berlaku. Jika Anda tidak
      setuju dengan perubahan pada Syarat dan Ketentuan, Anda dapat berhenti
      menggunakan Layanan Dompet Kilat.
    </p>
    <p class="title-1">XIII. HUBUNGI KAMI</p>

    <p class="Desc">
      Jika Anda memiliki pertanyaan atau membutuhkan informasi lebih lanjut,
      Anda dapat mengujungi laman FAQ (Frequently Asked Question) atau dapat
      menghubungi kami melalui layanan telepon (021) 400-00855 atau email
      cs@dompetkilat.co.id
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      marginLeft: `${window.innerWidth / 8}px`,
      width: `${window.innerWidth / 8}px`,
      height: `${window.innerWidth / 8}px`,
    };
  },
  mounted() {
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  created() {
    this.resizeEventHandler();
    window.addEventListener("resize", this.resizeEventHandler);
  },
  methods: {
    resizeEventHandler() {
      this.marginLeft = `${window.innerWidth / 4}px`;
      this.width = `${window.innerWidth / 2}px`;
      this.height = `${window.innerWidth / 3}px`;
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
  },
};
</script>
<style scoped>
.tanggal {
  flex-grow: 0;
  margin: 0 0 24px;
  font-family: Sora;
  font-size: 20px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -1px;
  text-align: left;
  color: #767676;
}
.title-1 {
  flex-grow: 0;
  margin: 24px 0 16px;
  font-family: Sora;
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.9px;
  text-align: left;
  color: #252525;
}
.Desc {
  flex-grow: 0;
  margin: 16px 0 24px;
  font-family: Inter;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: justify;
  color: #252525;
}
</style>
